import { create } from 'zustand';

export interface SessionUser {
  id: string;
  state: string;
}

interface SessionState {
  user: SessionUser | null;
  ready: boolean;
  deletionPhase: 'NONE' | 'REQUESTING' | 'ACCEPTED' | 'FAILED';
  beginDeletion: () => void;
  failDeletion: () => void;
  acceptDeletion: () => void;
  setSession: (user: SessionUser) => void;
  clear: () => void;
  expire: () => void;
}

export const useSession = create<SessionState>((set) => ({
  user: null,
  ready: false,
  deletionPhase: 'NONE',
  beginDeletion: () => set({ deletionPhase: 'REQUESTING' }),
  failDeletion: () => set({ deletionPhase: 'FAILED' }),
  acceptDeletion: () => set({ deletionPhase: 'ACCEPTED', user: null, ready: true }),
  setSession: (user) => {
    set({ user, ready: true });
  },
  clear: () => {
    set({ user: null, ready: true });
  },
  expire: () => {
    set({ user: null, ready: false });
  },
}));
